<div class="release-note-container">
  <div class="current-version-banner">
    <mat-icon>info</mat-icon>
    <span
      >Current DWO Version: <strong>v{{ groupedReleases[0]?.version }}</strong></span
    >
  </div>
  <h2>Release Notes</h2>

  <div *ngFor="let group of groupedReleases" class="release-version-group release-note-card">
    <div class="release-version-header">
      <span class="release-version">v{{ group.version }}</span>
      <span class="release-date">{{ group.date | date: 'mediumDate' }}</span>
    </div>
    <div class="release-notes" *ngFor="let release of group.notes">
      <div class="release-note-header">
        <span class="release-type" [ngClass]="release.type">
          <mat-icon *ngIf="release.type === 'feature'">auto_awesome</mat-icon>
          <mat-icon *ngIf="release.type === 'bugfix'">bug_report</mat-icon>
          {{ release.type | titlecase }}
        </span>
        <span class="release-note-title inline">{{ release.title }}</span>
      </div>
      <div class="release-note-description">{{ release.description }}</div>
    </div>
  </div>
</div>
